import React, { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import HomePage from './pages/Home'
import TermsPage from './pages/Terms'
import Nav from './components/Nav'
import Footer from './components/Footer'

function App() {
  const location = useLocation()

  const collapsedPaths = ["/terms"]

  const initialCollapsed = collapsedPaths.includes(location.pathname)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Nav initialCollapsed={initialCollapsed} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
      <Footer />
    </>
  )
}

export default App
